import * as React from 'react';
import { renderDatePicker_unstable } from './renderDatePicker';
import { useDatePicker_unstable } from './useDatePicker';
import { useDatePickerStyles_unstable } from './useDatePickerStyles';
export const DatePicker = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useDatePicker_unstable(props, ref);
  useDatePickerStyles_unstable(state);
  return renderDatePicker_unstable(state);
});
DatePicker.displayName = 'DatePicker';
//# sourceMappingURL=DatePicker.js.map